import { render, staticRenderFns } from "./FitmentStatusView.vue?vue&type=template&id=395d6af5&scoped=true&"
import script from "./FitmentStatusView.vue?vue&type=script&lang=js&"
export * from "./FitmentStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d6af5",
  null
  
)

export default component.exports